import I18n from '~/src/common/services/I18n';
import { formatBatchDiscountLabel } from '~/src/common/utils/prices';
import { ProductPromoWithBulkDiscount } from '~/src/common/utils/product';

import * as S from './layout';

interface Props {
  promo: ProductPromoWithBulkDiscount;
}

const BatchDiscountMessage = ({ promo }: Props) => {
  return (
    <S.BatchDiscountMessage>
      {I18n.t('toaster.batch-discount.message1')} <p>{formatBatchDiscountLabel(promo)}</p>{' '}
      {I18n.t('toaster.batch-discount.message2')}
    </S.BatchDiscountMessage>
  );
};

export default BatchDiscountMessage;
